module.exports = __webpack_public_path__ + "assets/img/story-flag.635a4ca6.svg";